export enum AgreeDisagreeEnum {
	Agree = 3,
	Disagree = 2,
	NA = 1,
}
